import { render, staticRenderFns } from "./Link_Small.vue?vue&type=template&id=e45f8968&"
import script from "./Link_Small.vue?vue&type=script&lang=js&"
export * from "./Link_Small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports